import { SANS_3, EmptyStates, UI_BODY_SM_DF } from "oolib";
import React from "react";
import { _Locale } from "../../../../components/locale/Locale";

const returnText = (totalCount, customText) => {
  switch (totalCount) {
    case "error":
      return "Something went wrong...";
    case "loading":
      return `${_Locale("Loading")} ${_Locale("results")}...`;
    case 0:
      return "No results";
    default:
      return customText
        ? customText
            .split("$count")
            .map((d) => _Locale(d.trim()))
            .join(` ${totalCount} `)
        : `${_Locale("Showing")} ${totalCount} ${_Locale("results")}  `;
  }
};

export const TotalCount = ({ totalCount, style, customText }) => {
  if (totalCount === undefined) return null;

  //else
  return (
    <div style={style}>
      <UI_BODY_SM_DF>{returnText(totalCount, customText)}</UI_BODY_SM_DF>
    </div>
  );
};
